import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_PRODUTO = [
  {
    module: 'PROD_CATEGORIA_PRODUTO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      }
    ]
  },
  {
    module: 'PROD_TABELA_PRECO',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'nome',
        active: true,
        removable: false
      }
      // {
      //   field: 'perc_desc_acresc',
      // active: true,
      // removable: true,
      // },
      // {
      //   field: 'perc_desc_acresc',
      // active: true,
      // removable: true,
      // }
      // {
      //   field: 'atualizar_auto',
      // active: true,
      // removable: true,
      // }
    ]
  },
  {
    module: 'PRODUTO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: true,
        field: 'codigo_barra'
      },
      {
        active: true,
        removable: true,
        field: 'produto.categoria.descricao'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'quantidade'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_minima'
      },
      {
        active: true,
        removable: true,
        field: 'valor_unitario'
      },
      {
        active: true,
        removable: true,
        field: 'usa_grade'
      }
    ]
  },
  {
    module: 'GRADE_PRODUTO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'sku'
      },
      {
        active: true,
        removable: true,
        field: 'codigo_barra'
      },
      {
        active: true,
        removable: true,
        field: 'categoria.descricao'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'quantidade'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_minima'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      }
    ]
  },
  {
    module: 'PROD_VARIACAO_PRODUTO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      }
    ]
  },
  {
    module: 'REE_PRODUTO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: true
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      {
        field: 'fornecedor.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'RSE_PRODUTO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      {
        field: 'observacao',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'TPE_PRODUTO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
